import { useMutation } from '@apollo/client';
import gql from 'graphql-tag';
import {
  MutationReportIssueArgs,
  ReportIssueOutput,
} from '@jupiterone/jupiter-web-toolkit/types/generated__reportIssue';
import { useSession, useUser } from '@jupiterone/jupiter-web-toolkit/src';

const REPORT_ISSUE = gql`
  mutation reportIssue($data: ReportIssueInput!) {
    reportIssue(data: $data) {
      created
    }
  }
`;
export const useReportIssue = () => {
  const [reportIssue, result] = useMutation<
    { reportIssue: ReportIssueOutput },
    MutationReportIssueArgs
  >(REPORT_ISSUE);
  const session = useSession();
  const { normalizedUserName } = useUser();

  const handleReportIssue = async (
    variables: Omit<MutationReportIssueArgs['data'], 'accountName'>
  ) => {
    await reportIssue({
      variables: {
        data: {
          ...variables,
          accountName: session.account?.name || '',
          userName: normalizedUserName,
        },
      },
    });
  };

  return {
    reportIssue: handleReportIssue,
    ...result,
  };
};
